import styled from '@emotion/styled'
import { Divider as MuiDivider } from '@mui/material'

export const Alert = styled('div')`
  background-color: #feeceb;
  padding: 10px;
  border-radius: 8px;
  margin-top: 10px;
`

export const AlertTitle = styled('div')`
  color: #e31b0c;
  font-weight: bold;
`

export const AlertDescription = styled.div`
  color: #3e3e3e;
`

export const Divider = styled(MuiDivider)`
  margin-top: 5px;
  margin-bottom: 5px;
`
